export abstract class BaseModel {
}

export type BaseModelConstructor = new (json: any) => BaseModel;
